define('formkit/view/block/compare.form.object.collections.view',['require','exports','module','underscore','marionette','uikit/uikit','../form.object/form.object.collections.by.section.collection.view','../form.object/form.object.collection.view','../form.object/compare.form.object.view'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var UIKit = require('uikit/uikit');
  var FormObjectCollectionsBySectionCollectionView = require('../form.object/form.object.collections.by.section.collection.view');
  var FormObjectCollectionView                     = require('../form.object/form.object.collection.view');
  var CompareFormObjectView                         = require('../form.object/compare.form.object.view');

  var CompareFormObjectCollectionBySectionCollectionView = FormObjectCollectionsBySectionCollectionView.extend({
    childView: FormObjectCollectionView.extend({
      className: FormObjectCollectionView.prototype.className + ' segments',
      childView: CompareFormObjectView,

      childViewOptions: function() {
        return _.extend({}, Mn._getValue(FormObjectCollectionView.prototype.childViewOptions, this),
        {
          comparing: true
        });
      }
    })
  });

  var CompareFormObjectCollectionsView = UIKit.ItemView.extend({
    template: function() {
      return '<div class="ui stackable two column grid">' +
      '<div class="column"><ui name="baseSubmissionHeaderView"/><ui name="baseCollectionView" /></div>' +
      '<div class="column"><ui name="driverSubmissionHeaderView"/><ui name="driverCollectionView" /></div></div>';
    },

    internalViewOptions: {
      baseSubmissionHeaderView: function() {
        return {
          type: UIKit.Header,
          text: 'Previous Submission',
          tagName: 'h4'
        }
      },
      baseCollectionView: function() {
        return {
          type: CompareFormObjectCollectionBySectionCollectionView,
          collection: this.getOption('baseForm').getTemplateModel().get('children'),
          form: this.getOption('baseForm'),
          readonly: true
        }
      },
      driverSubmissionHeaderView: function() {
        return {
          type: UIKit.Header,
          text: 'Current Submission',
          tagName: 'h4'
        }
      },
      driverCollectionView: function() {
        return {
          type: CompareFormObjectCollectionBySectionCollectionView,
          collection: this.getOption('driverForm').getTemplateModel().get('children'),
          form: this.getOption('driverForm'),
          readonly: true
        }
      }
    }
  });
  module.exports = CompareFormObjectCollectionsView;
});

